import axios from "axios";
import env from "../Env";
import moment from "moment";
export default {
  generateNDA: function (token, country, NDAData) {
    return new Promise((resolve, reject) => {
      let documentType = "nda";
      let url = `${process.env.VUE_APP_baseUrl}baanda/${documentType}/${country}`;
      axios
        .put(url, NDAData, { headers: { Authorization: `${token}` } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  viewNDAs: function (token) {
    return new Promise((resolve, reject) => {
      let documentType = "nda";
      let url = `${process.env.VUE_APP_baseUrl}baanda/ndas`;
      axios
        .get(url, { headers: { Authorization: `${token}` } })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },
  DownloadTemplate: function (token, fileId, fileName) {
    return new Promise((resolve, reject) => {
      let t = moment().unix();
      let url = `${process.env.VUE_APP_baseUrl}baanda/${fileId}/downloadtemplate/${fileName}`;
      axios({
        url: url,
        method: "GET",
        responseType: "blob",
        headers: { Authorization: `${token}`}
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
